import { render } from "./PrivacyPolicy.vue?vue&type=template&id=06c181fd&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=06c181fd&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c181fd"]])

export default __exports__